import { render, staticRenderFns } from "./SolutionCarousel.vue?vue&type=template&id=121be3b0&scoped=true"
import script from "./SolutionCarousel.vue?vue&type=script&lang=js"
export * from "./SolutionCarousel.vue?vue&type=script&lang=js"
import style0 from "./SolutionCarousel.vue?vue&type=style&index=0&id=121be3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121be3b0",
  null
  
)

export default component.exports